import React, { useState, useContext } from 'react';
import { AgendaContext } from '../../../contexts/AgendaContext';
// Mui components
import { Box, Button, TextField, Typography } from '@mui/material';
// Components
import SmallModalContainer from '../../common/SmallModalContainer';
import DotLoader from '../../common/Loaders/DotLoader/DotLoader.jsx';
import ModalSucessInformarProveedor from './ModalSucessInformarProveedor.flujoSolicitud.jsx';
import ModalErrorInformarProveedor from './ModalErrorInformarProveedor.flujoSolicitud.jsx'
// Icons
import iconClose from '../../../assets/icons/icon_close.svg';
import iconCircleWarningRed from '../../../assets/icons/icon_circle-warning-red.svg';


function ModalInformarProveedor({ openModal, onHandleClose }) {
  const { postInformarProveedor } = useContext(AgendaContext);

  const [informarProveedor, setInformarProveedor] = useState('');
  const [error, setError] = useState('');
  const [loader, setLoader] = useState(false);
  const [succesSolicitud, setSuccesSolicitud] = useState(false);
  const [errorSolicitud, setErrorSolicitud] = useState(false);

  const handleOnChange = (event) => {
    const { value } = event.target;
    const maxLength = 140;
    const regex = /^[a-zA-Z0-9\s]*$/; // No permite caracteres especiales

    if (value.length > maxLength) {
      setError(`El proveedor no puede superar los ${maxLength} caracteres.`);
    } else if (!regex.test(value)) {
      setError('El proveedor no puede contener caracteres especiales.');
    } else {
      setError('');
    }
    setInformarProveedor(value);
  };

  const handleClose = () => {
    setInformarProveedor('');
    setError('');
    setSuccesSolicitud(false);
    setErrorSolicitud(false);
    onHandleClose();
  };

  const handleEnviarProveedor = async () => {
    if (loader) return;
    setLoader(true);

    try {
      await postInformarProveedor(informarProveedor);
      setSuccesSolicitud(true);
      setErrorSolicitud(false);
    } catch (error) {
      setSuccesSolicitud(false);
      setErrorSolicitud(true);
      console.error('Error al enviar proveedor:', error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <SmallModalContainer open={openModal} onClose={handleClose}>
      
      {!errorSolicitud && !succesSolicitud && (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 450,
            bgcolor: '#FFF',
            padding: 4,
            borderRadius: 4
          }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Box
              component="img"
              sx={{ width: '24px', height: '24px', cursor: 'pointer' }}
              alt="img not found"
              src={iconClose}
              onClick={handleClose}
            />
          </Box>
          <Typography variant="h2" sx={{ mb: 2 }}>
            Informar proveedor
          </Typography>
          <Typography variant="h5">Indicanos el nombre de tu agenda digital.</Typography>
          <TextField
            onChange={handleOnChange}
            label="Proveedor"
            placeholder="Ingresalo"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            InputProps={{ notched: false }}
            fullWidth
            sx={{ mt: 2 }}
            error={error}
            helperText={
              error && (
                <Box sx={{ display: 'flex', alignItems: 'center', position: 'absolute' }}>
                  <Box
                    component="img"
                    sx={{ width: '16px', height: '16px' }}
                    alt="img not found"
                    src={iconCircleWarningRed}
                  />
                  <Typography variant="bodyS" color="error">
                    {error}
                  </Typography>
                </Box>
              )
            }
          />
          <Button
            disabled={informarProveedor === '' || error}
            sx={{ mt: 4, width: '100%', borderRadius: 4, py: 1.5 }}
            variant="contained"
            onClick={() => handleEnviarProveedor()}>
            Enviar
            {loader && (
              <Box sx={{ position: 'absolute', right: '10px' }}>
                <DotLoader />
              </Box>
            )}
          </Button>
        </Box>
      )}

      {succesSolicitud && !errorSolicitud && (
        <ModalSucessInformarProveedor openModal={succesSolicitud} onHandleClose={handleClose} />
      )}

      {errorSolicitud && !succesSolicitud && (
        <ModalErrorInformarProveedor openModal={errorSolicitud} onHandleClose={handleClose}/>
      )}
    </SmallModalContainer>
  );
}

export default ModalInformarProveedor;
